import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { POS_PAGE_SIZE } from '../../lib/posCatalog';

export const POSCatalogHeading = ({ search, total, page, onPageChange, mobile = false, displayLimit = POS_PAGE_SIZE }) => {
  const prefix = mobile ? 'pos-mobile-catalog' : 'pos-catalog';
  const pages = Math.max(1, Math.ceil(total / POS_PAGE_SIZE));
  return (
    <div className="flex items-center justify-between gap-2 text-xs shrink-0" data-testid={`${prefix}-heading`}>
      <h2 className="text-sm font-semibold">{search.trim() ? 'Search results' : 'Frequently sold'}</h2>
      <div className="flex items-center gap-2 text-muted-foreground">
        <span data-testid={`${prefix}-count`}>{total === 0 ? '0 items' : search.trim() ? `${Math.min(POS_PAGE_SIZE, total - (page - 1) * POS_PAGE_SIZE)} of ${total}` : `${Math.min(displayLimit, total)} items`}</span>
        {search.trim() && pages > 1 && <>
          <Button variant="outline" size="icon" className="h-7 w-7" title="Previous products" aria-label="Previous products" disabled={page <= 1} onClick={() => onPageChange(page - 1)} data-testid={`${prefix}-previous`}><ChevronLeft className="h-4 w-4" /></Button>
          <span data-testid={`${prefix}-page`}>{page}/{pages}</span>
          <Button variant="outline" size="icon" className="h-7 w-7" title="Next products" aria-label="Next products" disabled={page >= pages} onClick={() => onPageChange(page + 1)} data-testid={`${prefix}-next`}><ChevronRight className="h-4 w-4" /></Button>
        </>}
      </div>
    </div>
  );
};